import { render } from "./RequiredText.vue?vue&type=template&id=e3b2b1dc&scoped=true"
import script from "./RequiredText.vue?vue&type=script&lang=js"
export * from "./RequiredText.vue?vue&type=script&lang=js"

import "./RequiredText.vue?vue&type=style&index=0&id=e3b2b1dc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\shame\\.codex\\.chatgpt-projects\\g-p-6a9e6467fc748191a03e695eb5ba59d5\\build-work\\hr-dependent-frontend\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3b2b1dc"]])

export default __exports__